import { render, staticRenderFns } from "./MDMConfigComponent.vue?vue&type=template&id=72c6e3c6"
import script from "./MDMConfigComponent.vue?vue&type=script&lang=js"
export * from "./MDMConfigComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports